<template>
  <div class="home">
    <!-- Hero Section -->
    <section class="hero">
      <div class="hero-overlay"></div>
      <div class="hero-content container">
        <div class="hero-text">
          <h1 class="hero-title">
            榮譽源於品質
          </h1>
          <p class="hero-subtitle">
            Our goodwill is based on superior quality
          </p>
          <p class="hero-tagline">
            教育陪伴 · 遊學 · 旅遊
            <span class="hero-tagline-en">Education Companion · Study Tour · Travel</span>
          </p>
          <div class="hero-actions">
            <button @click="openAvatarChat" class="btn btn-secondary">
              數位人聊天
            </button>
            <router-link to="/service" class="btn btn-secondary">
              我們的服務
            </router-link>
          </div>
        </div>
        <div class="hero-visual">
          <div class="floating-card">
            <div class="card-icon">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <h3>Baikan Buddy 百看精靈</h3>
            <p>以 AI 教育陪伴為核心，串聯遊學與旅遊服務，為家庭與企業客戶提供一站式跨境體驗。</p>
          </div>
        </div>
      </div>
      <div class="scroll-indicator">
        <div class="scroll-arrow"></div>
      </div>
    </section>

    <!-- Features Section -->
    <section class="features">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">為什麼選擇 AMIS</h2>
          <p class="section-subtitle">專業的團隊，優質的服務，值得信賴的合作夥伴</p>
        </div>
        
        <div class="features-grid">
          <div class="feature-card" v-for="feature in features" :key="feature.id">
            <div class="feature-icon">
              <i :class="feature.icon"></i>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Business Lines Section -->
    <section class="business">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">三大業務板塊</h2>
          <p class="section-subtitle">教育陪伴 · 遊學 · 旅遊，一次對接全部搞定</p>
        </div>

        <div class="business-grid">
          <router-link
            class="business-card"
            v-for="line in businessLines"
            :key="line.id"
            :to="line.to"
          >
            <div class="business-icon">
              <i :class="line.icon"></i>
            </div>
            <h3 class="business-title">{{ line.title }}</h3>
            <p class="business-en">{{ line.en }}</p>
            <p class="business-description">{{ line.description }}</p>
            <span class="business-more">了解更多 ></span>
          </router-link>
        </div>
      </div>
    </section>

    <!-- Stats Section -->
    <section class="stats">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item" v-for="stat in stats" :key="stat.id">
            <div class="stat-number">{{ stat.number }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- Avatar Chat Modal -->
    <AvatarChat v-if="showAvatarChat" @close="closeAvatarChat" />
  </div>
</template>

<script>
import AvatarChat from '@/components/AvatarChat.vue'

export default {
  name: 'AmisHome',
  components: {
    AvatarChat
  },
  data() {
    return {
      showAvatarChat: false,
      businessLines: [
        {
          id: 1,
          icon: 'fas fa-comments',
          title: '教育陪伴',
          en: 'Education Companion',
          description: '旗下品牌 Baikan Buddy 百看精靈以 AI 對話陪伴孩子語言學習與日常成長，家長隨時掌握進度。',
          to: '/service'
        },
        {
          id: 2,
          icon: 'fas fa-graduation-cap',
          title: '遊學',
          en: 'Study Tour',
          description: '香港、英國、德國、西班牙、美國等地遊學與研學行程，全程專業顧問跟進。',
          to: '/service'
        },
        {
          id: 3,
          icon: 'fas fa-plane',
          title: '旅遊',
          en: 'Travel',
          description: '精選行程、酒店預訂與商務出行，從諮詢到落地提供完整的一站式旅遊方案。',
          to: '/service'
        }
      ],
      features: [
        {
          id: 1,
          icon: 'fas fa-users',
          title: '專業團隊',
          description: '擁有超過十年的行業經驗，專業的教育、遊學與旅遊服務團隊為您提供最優質的體驗。'
        },
        {
          id: 2,
          icon: 'fas fa-shield-alt',
          title: '品質保證',
          description: '嚴格的品質控制體系，確保每一次服務都達到最高標準。'
        },
        {
          id: 3,
          icon: 'fas fa-clock',
          title: '24/7 服務',
          description: '全天候客戶服務，隨時為您解答疑問，提供支持。'
        },
        {
          id: 4,
          icon: 'fas fa-handshake',
          title: '一站式解決方案',
          description: '從諮詢到實施，提供教育陪伴、遊學與旅遊的完整解決方案。'
        }
      ],
      stats: [
        { id: 1, number: '10+', label: '年行業經驗' },
        { id: 2, number: '1000+', label: '服務家庭' },
        { id: 3, number: '50+', label: '服務國家' },
        { id: 4, number: '99%', label: '客戶滿意度' }
      ]
    }
  },
  methods: {
    openAvatarChat() {
      this.showAvatarChat = true
    },
    closeAvatarChat() {
      this.showAvatarChat = false
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  padding-top: 80px; // Account for fixed header
}

.hero {
  position: relative;
  height: 100vh;
  background-image: url("../assets/bg_landscape.webp");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  align-items: center;
  overflow: hidden;
  
  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(137, 177, 185, 0.8) 0%, rgba(53, 53, 54, 0.6) 100%);
    z-index: 1;
  }
  
  .hero-content {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: var(--spacing-3xl);
    align-items: center;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      text-align: center;
    }
  }
  
  .hero-text {
    .hero-title {
      font-size: clamp(2.5rem, 5vw, 4rem);
      font-weight: 700;
      color: white;
      margin-bottom: var(--spacing-lg);
      line-height: 1.2;
      text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
    }
    
    .hero-subtitle {
      font-size: clamp(1.25rem, 2.5vw, 1.75rem);
      color: rgba(255, 255, 255, 0.9);
      margin-bottom: var(--spacing-md);
      font-weight: 300;
    }

    .hero-tagline {
      font-size: clamp(1rem, 2vw, 1.25rem);
      color: #ffffff;
      font-weight: 600;
      letter-spacing: 2px;
      margin-bottom: var(--spacing-2xl);
      text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3);

      .hero-tagline-en {
        display: block;
        margin-top: 6px;
        font-size: 0.75rem;
        font-weight: 400;
        letter-spacing: 1px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
    
    .hero-actions {
      display: flex;
      gap: var(--spacing-lg);
      
      @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
      }
    }
  }
  
  .hero-visual {
    display: flex;
    justify-content: center;
    align-items: center;
    
    .floating-card {
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      padding: var(--spacing-2xl);
      border-radius: var(--radius-xl);
      box-shadow: var(--shadow-xl);
      text-align: center;
      max-width: 300px;
      animation: float 6s ease-in-out infinite;
      
      .card-icon {
        font-size: 3rem;
        color: var(--primary-text);
        margin-bottom: var(--spacing-lg);
      }
      
      h3 {
        font-size: var(--font-size-xl);
        color: var(--text-primary);
        margin-bottom: var(--spacing-md);
      }
      
      p {
        color: var(--text-secondary);
        line-height: 1.6;
      }
    }
  }
  
  .scroll-indicator {
    position: absolute;
    bottom: var(--spacing-xl);
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    
    .scroll-arrow {
      width: 30px;
      height: 30px;
      border: 2px solid white;
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
      animation: bounce 2s infinite;
    }
  }
}

.features {
  padding: var(--spacing-3xl) 0;
  background: var(--background-light);
  
  .section-header {
    text-align: center;
    margin-bottom: var(--spacing-3xl);
    
    .section-title {
      font-size: var(--font-size-4xl);
      color: var(--text-primary);
      margin-bottom: var(--spacing-md);
      font-weight: 700;
    }
    
    .section-subtitle {
      font-size: var(--font-size-lg);
      color: var(--text-secondary);
      max-width: 600px;
      margin: 0 auto;
    }
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: var(--spacing-2xl);
    
    .feature-card {
      background: white;
      padding: var(--spacing-2xl);
      border-radius: var(--radius-lg);
      box-shadow: var(--shadow-md);
      text-align: center;
      transition: var(--transition-normal);
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: var(--shadow-lg);
      }
      
      .feature-icon {
        font-size: 3rem;
        color: var(--primary-text);
        margin-bottom: var(--spacing-lg);
      }
      
      .feature-title {
        font-size: var(--font-size-xl);
        color: var(--text-primary);
        margin-bottom: var(--spacing-md);
        font-weight: 600;
      }
      
      .feature-description {
        color: var(--text-secondary);
        line-height: 1.6;
      }
    }
  }
}

.business {
  padding: var(--spacing-3xl) 0;
  background: white;

  .section-header {
    text-align: center;
    margin-bottom: var(--spacing-3xl);

    .section-title {
      font-size: var(--font-size-4xl);
      color: var(--text-primary);
      margin-bottom: var(--spacing-md);
      font-weight: 700;
    }

    .section-subtitle {
      font-size: var(--font-size-lg);
      color: var(--text-secondary);
    }
  }

  .business-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: var(--spacing-2xl);

    .business-card {
      display: block;
      background: var(--background-light);
      border: 1px solid var(--primary-light);
      border-radius: var(--radius-lg);
      padding: var(--spacing-2xl);
      text-align: center;
      text-decoration: none;
      transition: var(--transition-normal);

      &:hover {
        transform: translateY(-5px);
        box-shadow: var(--shadow-lg);
        border-color: var(--primary-color);
      }

      .business-icon {
        font-size: 2.5rem;
        color: var(--primary-text);
        margin-bottom: var(--spacing-md);
      }

      .business-title {
        font-size: var(--font-size-2xl);
        color: var(--text-primary);
        font-weight: 700;
        margin-bottom: 2px;
      }

      .business-en {
        font-size: var(--font-size-sm);
        color: var(--primary-text);
        letter-spacing: 1px;
        margin-bottom: var(--spacing-md);
      }

      .business-description {
        color: var(--text-secondary);
        line-height: 1.7;
        margin-bottom: var(--spacing-lg);
      }

      .business-more {
        color: var(--primary-text);
        font-weight: 600;
        font-size: var(--font-size-sm);
      }
    }
  }
}

.stats {
  padding: var(--spacing-3xl) 0;
  background: var(--primary-text);
  
  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--spacing-2xl);
    text-align: center;
    
    .stat-item {
      .stat-number {
        font-size: var(--font-size-5xl);
        font-weight: 700;
        color: white;
        margin-bottom: var(--spacing-sm);
      }
      
      .stat-label {
        font-size: var(--font-size-lg);
        color: rgba(255, 255, 255, 0.9);
        font-weight: 500;
      }
    }
  }
}

// Buttons
.btn {
  display: inline-block;
  padding: var(--spacing-md) var(--spacing-xl);
  border-radius: var(--radius-lg);
  text-decoration: none;
  font-weight: 600;
  transition: var(--transition-fast);
  border: 2px solid transparent;
  
  &.btn-primary {
    background: var(--primary-text);
    color: white;
    
    &:hover {
      background: var(--primary-text-hover);
      transform: translateY(-2px);
    }
  }
  
  &.btn-secondary {
    background: transparent;
    color: white;
    border-color: white;
    
    &:hover {
      background: white;
      color: var(--text-primary);
      transform: translateY(-2px);
    }
  }
}

// Animations
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0) rotate(45deg);
  }
  40% {
    transform: translateY(-10px) rotate(45deg);
  }
  60% {
    transform: translateY(-5px) rotate(45deg);
  }
}

// Responsive Design
@media (max-width: 768px) {
  .hero {
    .hero-content {
      padding: 0 var(--spacing-md);
    }
    
    .floating-card {
      max-width: 100%;
    }
  }
  
  .features {
    .features-grid {
      grid-template-columns: 1fr;
    }
  }
  
  .stats {
    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
</style>
